import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const companyOnlyMatch: CanMatchFn = () => inject(AuthService).user?.type === 'company';

export const notCompanyMatch: CanMatchFn = () => inject(AuthService).user?.type !== 'company';

export const domainExpertOnlyMatch: CanMatchFn = () => inject(AuthService).user?.type === 'domain_expert';

export const studentOnlyMatch: CanMatchFn = () => {
  const type = inject(AuthService).user?.type;
  return type !== 'company' && type !== 'domain_expert';
};
